/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Percentage difference uses the average of the two numbers, so swapping them gives the same result.`)
};

const es_pct_difference_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La diferencia porcentual usa el promedio de los dos números, así que intercambiarlos da el mismo resultado.`)
};

const de_pct_difference_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Der prozentuale Unterschied nutzt den Durchschnitt der beiden Zahlen, daher liefert ein Vertauschen dasselbe Ergebnis.`)
};

const nl_pct_difference_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Percentageverschil gebruikt het gemiddelde van de twee getallen, dus als je ze omwisselt, krijg je hetzelfde resultaat.`)
};

const fr_pct_difference_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. La différence en pourcentage utilise la moyenne des deux nombres, donc les inverser donne le même résultat.`)
};

const it_pct_difference_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La differenza percentuale usa la media dei due numeri, quindi scambiarli dà lo stesso risultato.`)
};

const pt_br2_pct_difference_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A diferença percentual usa a média dos dois números, então trocá-los de posição dá o mesmo resultado.`)
};

const pt_pct_difference_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A diferença percentual usa a média dos dois números, por isso trocá-los dá o mesmo resultado.`)
};

const ja_pct_difference_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。パーセントの差は2つの数値の平均を使うため、順序を入れ替えても結果は同じです。`)
};

const zh_pct_difference_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不重要。百分比差异使用两个数字的平均值，因此交换顺序结果不变。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_faq2_a", locale)
	if (locale === "en") return en_pct_difference_faq2_a(inputs)
	if (locale === "es") return es_pct_difference_faq2_a(inputs)
	if (locale === "de") return de_pct_difference_faq2_a(inputs)
	if (locale === "nl") return nl_pct_difference_faq2_a(inputs)
	if (locale === "fr") return fr_pct_difference_faq2_a(inputs)
	if (locale === "it") return it_pct_difference_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_faq2_a(inputs)
	if (locale === "pt") return pt_pct_difference_faq2_a(inputs)
	if (locale === "ja") return ja_pct_difference_faq2_a(inputs)
	return zh_pct_difference_faq2_a(inputs)
};